module.exports = function logout() {
  localStorage.removeItem("vsToken");
};
